import { render, staticRenderFns } from "./ball.vue?vue&type=template&id=79a0543e&scoped=true&"
import script from "./ball.vue?vue&type=script&lang=js&"
export * from "./ball.vue?vue&type=script&lang=js&"
import style0 from "./ball.vue?vue&type=style&index=0&id=79a0543e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a0543e",
  null
  
)

export default component.exports